import { createContext, useEffect, useState, useContext } from "react";
import {
    signOut,
    onAuthStateChanged
} from 'firebase/auth'
import { auth } from '../firebase_conf'

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
    const [user, setUser] = useState({});

    function logOut(){
        setUser([]);
        return signOut(auth);
    }
    function addUserInfo(user){
        setUser(user);
    }
    useEffect( () => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => {
            unsubscribe();
        }
    }, []);
    return <userAuthContext.Provider value={{user, addUserInfo, logOut}}>{children}</userAuthContext.Provider>
}

export function useUserAuth() {
    return useContext(userAuthContext);
}